import React from 'react';
import { LuExpand } from 'react-icons/lu';
import { Link } from 'react-router-dom';

import { StandaloneTask } from '../../entities/standalone-task';
import MarkdownRenderer from '../MarkdownRenderer';
import { Modal } from '../ui/Modal';

const PRIORITY_BADGE: Record<NonNullable<StandaloneTask['priority']>, string> = {
  low: 'badge-ghost',
  medium: 'badge-info',
  high: 'badge-error',
};

interface LinkedTaskPreviewModalProps {
  task: StandaloneTask;
  onClose: () => void;
}

// A quick read-only look at a task linked from elsewhere (today: a coding-agent task's
// standaloneTaskId) — full editing stays on the task's own page, reached via "Open full page".
export const LinkedTaskPreviewModal: React.FC<LinkedTaskPreviewModalProps> = ({ task, onClose }) => (
  <Modal onClose={onClose} className="max-w-2xl max-h-[85vh] overflow-y-auto" labelledBy="linked-task-preview-title">
    <div className="card-body p-5 gap-3">
      <div className="flex items-center justify-between gap-2">
        <div id="linked-task-preview-title" className="flex items-center gap-2 min-w-0">
          <span className="font-mono text-xs opacity-40 shrink-0">{task.key}</span>
          {task.priority && (
            <span className={`badge badge-sm shrink-0 ${PRIORITY_BADGE[task.priority]}`}>{task.priority}</span>
          )}
        </div>
        <Link to={`/standalone/tasks/${task.key}`} className="btn btn-ghost btn-xs gap-1 shrink-0" onClick={onClose}>
          <LuExpand size={12} />
          Open full page
        </Link>
      </div>
      <h2 className="text-lg font-semibold">{task.title}</h2>
      {task.dueDate && <p className="text-xs opacity-50">Due {new Date(task.dueDate).toLocaleDateString()}</p>}
      {task.description ? (
        <MarkdownRenderer markdown={task.description} />
      ) : (
        <p className="text-sm opacity-40">No description.</p>
      )}
    </div>
  </Modal>
);

export default LinkedTaskPreviewModal;
